import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';

import { getPnProperty, fetchRemainingUnlocks } from 'helpers/clarity_api';
import PropertyContacts from './property_contacts';

export default function DataPropertyContacts({ id }) {
  const [loading, setLoading] = useState(true);
  const [remainingUnlocks, setRemainingUnlocks] = useState(0);
  const [unlockedOwners, setUnlockedOwners] = useState(false);

  useEffect(() => {
    const getProperty = getPnProperty(id)
      .then(property => setUnlockedOwners(!!property?.unlock_owners_at))
      .catch(() => setUnlockedOwners(false));
    const getRemainingUnlocks = fetchRemainingUnlocks()
      .then(setRemainingUnlocks)
      .catch(() => setRemainingUnlocks(0));

    Promise.all([getProperty, getRemainingUnlocks]).then(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="text-center py-4">
        <FontAwesomeIcon beatFade className="text-primary" icon={faBuildoutLogo} size="3x" />
      </div>
    );
  }

  if (unlockedOwners)  return <PropertyContacts id={id} />;

  if (remainingUnlocks === 0) {
    return (
      <div className="text-center">
        <p className="text-danger">
          You are not authorized to obtain information from owners. You've exhausted your credits this month.
        </p>
      </div>  
    );
  }

  return (
    <div className="text-center">
      <p className="text-danger">You have {remainingUnlocks} credits remaining</p>

      <Button variant="primary" onClick={() => setUnlockedOwners(true)}>
        Unlock Contacts (1 credit)
      </Button>
    </div>
  );
}

DataPropertyContacts.propTypes = {
  id: PropTypes.number.isRequired,
};
